import { createReducer, on } from '@ngrx/store';
import { AppState } from '../app.state';
import * as AppActions from '../actions/app.action';

export const initialState: AppState = {
  selectedPRF: {
    prfyear: null,
    groupcode: null,
    prfnumber: null,
    prfname: null,
    groupreportenabled: '',
    prfstatus: ''
  }
};

export const appReducer = createReducer(
  initialState,
  on(AppActions.getCompanyInfoSuccess, (state, { companyInfo }) => ({
    ...state,
    selectedPRF: {
      ...state.selectedPRF,
      prfname: companyInfo.prfname
    }
  })),
  on(AppActions.setCompanyInfo, (state, { prfnumber, prfname, prfyear, groupcode, groupreportenabled, prfstatus }) => ({
    ...state,
    selectedPRF: {
      ...state.selectedPRF,
      prfnumber,
      prfname,
      prfyear,
      groupcode,
      groupreportenabled: groupreportenabled !== undefined ? groupreportenabled : state.selectedPRF.groupreportenabled,
      prfstatus
    }
  })),
  on(AppActions.clearCompanyInfo, () => initialState)
);
